import { render, staticRenderFns } from "./mallManagement.vue?vue&type=template&id=9b8f4e5e&scoped=true"
import script from "./mallManagement.vue?vue&type=script&lang=js"
export * from "./mallManagement.vue?vue&type=script&lang=js"
import style0 from "./mallManagement.vue?vue&type=style&index=0&id=9b8f4e5e&prod&lang=scss&scoped=true"
import style1 from "./mallManagement.vue?vue&type=style&index=1&id=9b8f4e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8f4e5e",
  null
  
)

export default component.exports